import { Helmet } from 'react-helmet-async';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';

import { DetailsPageCommon } from 'src/components/details/details';

import { ChannelStepView } from './components/channel-step-view';

// ----------------------------------------------------------------------

const metadata = { title: `Create Channel | Channel - ${CONFIG.appName}` };

export default function ChannelStepPage() {
  const { t } = useTranslate('navbar');

  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <DetailsPageCommon
        heading={`${t('CHANNEL')}`}
        breadcrumbsLink={[
          { name: `${t('CHANNEL')}`, href: paths.channel.root },
          { name: `${t('CREATE_CHANNEL')}`, href: paths.channel.step },
        ]}
        components={<ChannelStepView />}
      />
    </>
  );
}
